import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { emptyArray } from 'ui-components/default-props/empty';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { get3PDeliverablesDetails } from './api';
import messages from './messages';
import Overview from './overview';
import ShipmentDetails from './shipment-details';
import style from './style.module.less';

const ThirdPDOModal = ({ storeGuid, thirdPartyDeliveryNumber, orderNumber }) => {
  const [details, setDetails] = useAsyncSafeState();
  const [isLoading, setIsLoading] = useAsyncSafeState(true);
  const [hasError, setHasError] = useAsyncSafeState(false);

  useEffect(() => {
    get3PDeliverablesDetails(storeGuid, thirdPartyDeliveryNumber)
      .then(setDetails)
      .catch(() => setHasError(true))
      .finally(() => setIsLoading(false));
  }, [storeGuid, thirdPartyDeliveryNumber, setDetails, setIsLoading, setHasError]);

  const { summary = {}, shipments = emptyArray } = details ?? {};
  return (
    <Modal className={style.modal}>
      <ModalHeader>
        <FormattedMessage {...messages.thirdPDOModalTitle} />
      </ModalHeader>
      <ModalBody className={style.body}>
        {isLoading && <LoadingIndicator className={style['loading-indicator']} theme='grey' />}
        {!isLoading && hasError && <FormattedMessage {...messages.onErrorMessage} />}
        {!isLoading && !hasError && details && (
          <>
            <Overview orderNumber={orderNumber} overview={summary} thirdPartyDeliveryNumber={thirdPartyDeliveryNumber} />
            {shipments.map((shipment) => (
              <ShipmentDetails key={shipment.carrierId} shipment={shipment} />
            ))}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ThirdPDOModal;

ThirdPDOModal.propTypes = {
  storeGuid: PropTypes.string.isRequired,
  thirdPartyDeliveryNumber: PropTypes.string.isRequired,
  orderNumber: PropTypes.string.isRequired,
};
